"use client";

import styles from "../page.module.css";
import { useUserDataContext } from "../user-data-context";

export function NameTitle() {
  const { state } = useUserDataContext();

  return <h1 className={styles.name}>{state.complete_name}</h1>;
}
